<template>
  <div>
    <div v-if="editGroup">

      <table class="table table-sm mt-0 table-hover">
        <thead>
        <tr>
          <th>группа</th>
          <th>смена 1</th>
          <!--          <th></th>-->
          <th class="mw_ht">кол.</th>
          <th class="mw_ht">кол.</th>
          <th>смена 2</th>
          <th>график</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(r, groupIndex) in editGroup.data">
          <tr class="first_block_tr">
            <td :rowspan="r.users.shift_1.length * (usersRows + 1) + 1">
              <p>{{ r.group?.title ?? 'no title' }}</p>
              <template v-if="r.group?.data?.projects">
                <p><span
                  v-for="(p,i) in r.group.data.projects">{{ i !== 0 ? ', ' : '' }}{{ $AllProjects[p]?.title }}</span>
                </p>
              </template>
              <template v-else>
                <p>Все проекты</p>
              </template>
            </td>
            <td colspan="4" class="empty_td"/>
            <td :rowspan="r.users.shift_1.length * (usersRows + 1) + 1">
              <p>{{ schedule[r.schedule]?.start }}</p>
              <p>{{ schedule[r.schedule]?.end }}</p>
            </td>
          </tr>
          <template v-for="(u, i) in r.users.shift_1">
            <tr>
              <td :rowspan="usersRows + 1">
                <template v-if="u?.id">
                  <strong>({{ u?.id }}) {{ u?.id === -1 ? 'Вся группа' : u?.name }}</strong>
                  <i>{{ u?.role }}</i>
                </template>
              </td>
              <td colspan="2" class="empty_td"/>
              <td :rowspan="usersRows + 1">
                <template v-if="r.users.shift_2[i]?.id">
                  <strong>({{ r.users.shift_2[i]?.id }})
                    {{ r.users.shift_2[i]?.id === -1 ? 'Вся группа' : r.users.shift_2[i]?.name }}</strong>
                  <i>{{ r.users.shift_2[i]?.role }}</i>
                </template>
              </td>
            </tr>
            <tr>
              <td v-for="shift in [1,2]">
                <template v-if="usersStats[r.users['shift_'+shift][i]?.id]?.[r.schedule]">
                  <p>Заявок: <strong>{{ usersStats[r.users['shift_' + shift][i].id][r.schedule].total_orders }}</strong>
                  </p>
                  <p>Всего звонков:
                    <strong>{{ usersStats[r.users['shift_' + shift][i].id][r.schedule].total_calls }}</strong></p>
                  <p>Всего минут:
                    <strong>{{ usersStats[r.users['shift_' + shift][i].id][r.schedule].total_call_duration }}</strong>
                  </p>
                  <p>На сумму:
                    <strong>{{ usersStats[r.users['shift_' + shift][i].id][r.schedule].total_price }}</strong></p>
                  <p>Сумма по коэфф:
                    <strong>{{ usersStats[r.users['shift_' + shift][i].id][r.schedule].total_price_by_rate }}</strong>
                  </p>
                </template>
              </td>
            </tr>
            <tr>
              <td>{{ r.schedule }}</td>
              <td>{{ r.users.shift_2[i]?.id }}</td>
            </tr>
          </template>
        </template>
        </tbody>
      </table>

      <table v-if="false" class="table table-sm table-hover mt-1">
        <thead>
        <tr>
          <th>группа</th>
          <th>смена 1</th>
          <th></th>
          <th class="mw_ht">кол.</th>
          <th class="mw_ht">сумм.</th>
          <th class="mw_ht">кол.об</th>
          <th class="mw_ht">сумм.об</th>
          <th class="mw_ht">сумм.</th>
          <th class="mw_ht">кол.</th>
          <th>смена 2</th>
          <th>график</th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(r, groupIndex) in editGroup.data" v-if="!r.to_delete">
          <tr class="first_block_tr">
            <td :rowspan="r.users.shift_1.length * (rowspanUser + 1) + 1">
              <p>{{ r.group?.title ?? 'no title' }}</p>
              <template v-if="r.group?.data?.projects">
                <p><span
                  v-for="(p,i) in r.group.data.projects">{{ i !== 0 ? ', ' : '' }}{{ $AllProjects[p]?.title }}</span>
                </p>
              </template>
              <template v-else>
                <p>Все проекты</p>
              </template>
            </td>
            <td class="empty_td" colspan="9"/>
            <td :rowspan="r.users.shift_1.length * (rowspanUser + 1) + 1">{{
                schedule[r.schedule].start.substring(0, schedule[r.schedule].start.length - 3)
              }} - {{
                schedule[r.schedule].end.substring(0, schedule[r.schedule].end.length - 3)
              }}
            </td>
          </tr>
          <template v-for="(u, i) in r.users.shift_1">
            <tr>
              <td :rowspan="rowspanUser + 1">
                <template v-if="r.users.shift_1[i]?.id">
                  <strong>({{ r.users.shift_1[i]?.id }}) {{
                      r.users.shift_1[i]?.id === -1 ? 'Вся группа' : r.users.shift_1[i]?.name
                    }}</strong>
                  <i>{{ r.users.shift_1[i]?.role }}</i>
                </template>
              </td>
              <td class="empty_td" colspan="7"/>
              <td :rowspan="rowspanUser + 1">
                <template v-if="r.users.shift_2[i]?.id">
                  <strong>({{ r.users.shift_2[i]?.id }}) {{
                      r.users.shift_2[i]?.id === -1 ? 'Вся группа' : r.users.shift_2[i]?.name
                    }}</strong>
                  <i>{{ r.users.shift_2[i]?.role }}</i>
                </template>
              </td>
            </tr>
            <template v-for="ii in rowspanUser">
              <template v-if="ii === 1">
                <tr class="tr_total_orders">
                  <td colspan="7" align="center"><p v-html="getSum('total', 'orders', i, r)"/></td>
                </tr>
              </template>
              <template v-if="usersStatsList[ii-2]?.type === 'orders'">
                <tr>
                  <td><span :class="usersStatsList[ii-2].span">{{ usersStatsList[ii - 2].abbreviation }}</span></td>
                  <td class="total_order_figures"><p v-html="getSum(usersStatsList[ii-2].alias, 'total', i, r, 1)"/>
                  </td>
                  <td class="bg_1"><p v-html="getSum(usersStatsList[ii-2].alias, 'sum', i, r, 1)"/></td>
                  <td class=""><p
                    v-html="getSum(usersStatsList[ii-2].alias, 'grand_total', i, r, 1)"/></td>
                  <td class=""><p v-html="getSum(usersStatsList[ii-2].alias, 'grand_sum', i, r, 1)"/>
                  </td>
                  <td class="bg_1"><p v-html="getSum(usersStatsList[ii-2].alias, 'sum', i, r, 2)"/></td>
                  <td class="total_order_figures"><p v-html="getSum(usersStatsList[ii-2].alias, 'total', i, r, 2)"/>
                  </td>
                </tr>
              </template>
            </template>
          </template>
        </template>
        </tbody>
      </table>

      <table v-if="false" class="table table-sm table-hover mt-1">
        <thead>
        <tr>
          <th>Группа</th>
          <th>проекты</th>
          <th>смена 1</th>
          <th colspan="3" :class="{'stat_td': !!stats}"/>
          <th>смена 2</th>
          <th class="w-small">график</th>
          <th></th>
        </tr>
        </thead>
        <tbody>
        <template v-for="(r, ii) in editGroup.data" v-if="!r.to_delete">
          <tr :class="{'gray': ii % 2}">
            <td
              :rowspan="groupRowSpan[r.group.id]">
              {{ allGroups.find((g) => g.id === r.group.id)?.title }}
            </td>
            <td
              :rowspan="groupRowSpan[r.group.id]">
              <template v-if="r?.group?.data?.projects">
                <div class="flex flex_gap_10 flex-wrap">
              <span class="badge badge-info" v-for="p in r.group.data.projects">
                {{ $AllProjects[p]?.title }}
              </span>
                </div>
              </template>
              <template v-else>
                Все проекты
              </template>
            </td>
            <template v-if="!!stats">
              <td/>
              <td>
                <ShiftOrdersStat :allRecords="stats[r.schedule] ?? {}"
                                 :allUsers="[...r.users.shift_1, ...r.users.shift_2]" :users="r.users.shift_1"/>
              </td>
              <td/>
              <td>
                <ShiftOrdersStat :allRecords="stats[r.schedule] ?? {}"
                                 :allUsers="[...r.users.shift_1, ...r.users.shift_2]" :users="r.users.shift_2"/>
              </td>
              <td/>
            </template>
            <template v-else>
              <td class="empty_td" colspan="5"/>
            </template>
            <td
              :rowspan="groupRowSpan[r.group.id]">
              <select v-model="r.schedule" :disabled="!!editGroup.id" class="form-control">
                <option value="0" disabled>Выберите график</option>
                <option v-for="s in schedule" :value="s.id">{{ s.start }} - {{ s.end }} {{ s.title }}</option>
              </select>
            </td>
          </tr>
          <tr
            :class="{'gray': ii % 2}"
            v-for="i in (groupRowSpan[r.group.id] - 1)">
            <td>
              <span v-if="r.users?.shift_1?.[i -1]">({{ r.users.shift_1[i - 1]?.id }}) {{
                  r.users.shift_1[i - 1]?.name
                }} ({{
                  r.users.shift_1[i - 1]?.role
                }})</span>
              <p><strong>{{ printUserStat(stats[r.schedule]?.[r.users.shift_1[i - 1]?.id] ?? {}) }}</strong></p>
            </td>
            <td>
              <ManagerOrdersStats v-if="stats && r.users?.shift_1?.[i -1]"
                                  :allShift="getAllShiftStats(r, 1)"
                                  :stats="stats[r.schedule]?.[r.users.shift_1[i - 1]?.id] ?? {}"/>
            </td>
            <td>
              <ManagerOrdersStatsDiff v-if="stats && (r.users?.shift_1?.[i -1] || r.users?.shift_2?.[i -1])"
                                      :stats1="stats[r.schedule]?.[r.users.shift_1[i - 1]?.id] ?? {}"
                                      :stats2="stats[r.schedule]?.[r.users.shift_2[i - 1]?.id] ?? {}"/>
            </td>
            <td>
              <ManagerOrdersStats v-if="stats && r.users?.shift_2?.[i -1]"
                                  :allShift="getAllShiftStats(r, 2)"
                                  :stats="stats[r.schedule]?.[r.users.shift_2[i - 1]?.id] ?? {}"/>
            </td>
            <td>
              <span v-if="r.users?.shift_2?.[i -1]">({{ r.users.shift_2[i - 1]?.id }}) {{
                  r.users.shift_2[i - 1]?.name
                }} ({{
                  r.users.shift_2[i - 1]?.role
                }})</span>
              <p><strong>{{ printUserStat(stats[r.schedule]?.[r.users.shift_2[i - 1]?.id] ?? {}) }}</strong></p>
            </td>
          </tr>
        </template>
        </tbody>
      </table>

      <div class="text-right" v-if="!editGroup.id">
        <LoadingButton
          title='Сохранить'
          type="button"
          :loading="loading"
          :onClick="() => saveGroup()"
          :color="$constants.SUCCESS_COLOR"
          className="btn btn-outline-success"
        />
      </div>
    </div>
  </div>
</template>

<script>

import Multiselect from 'vue-multiselect'
import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";
import UserName from "@/components/users/UserName.vue";
import ManagerOrdersStats from "@/views/users/components/ManagerOrdersStats.vue";
import ManagerOrdersStatsDiff from "@/views/users/components/ManagerOrdersStatsDiff.vue";
import ShiftOrdersStat from "@/views/users/components/ShiftOrdersStat.vue";
import moment from 'moment';

export default {
  props: ['editGroup', 'allGroups', 'allUsers', 'savedGroup', 'schedule', 'stats', 'dateRange'],
  components: {ShiftOrdersStat, ManagerOrdersStatsDiff, ManagerOrdersStats, UserName, LoadingButton, Multiselect},
  data() {
    return {
      pageHash: null,
      usersRows: 2,
      rowspanUser: 6,
      usersStats: {},
      usersStatsList: [
        {type: 'orders', alias: 'probablyClose', span: 'badge badge-success', abbreviation: 'У'},
        {type: 'orders', alias: 'closedOrders', span: 'badge badge-success', abbreviation: 'З'},
        {type: 'orders', alias: 'done', span: 'badge badge-info', abbreviation: 'О'},
        {type: 'orders', alias: 'rej_man', span: 'badge badge-warning', abbreviation: 'M'},
        {type: 'orders', alias: 'rej_run', span: 'badge badge-warning', abbreviation: 'K'},
      ],
      loading: false,
      groupRowSpan: {},
      record: {
        data: [{group: null, users: {shift_1: [], shift_2: []}, schedule: 0}],
      }
    }
  },
  mounted() {
    const ids = {};
    this.editGroup.data.forEach((d) => {
      if (d.users.shift_1.length > 1) {
        d.users.shift_1 = [{id: -1, name: 'group_total'}, ...d.users.shift_1]
        d.users.shift_2 = [{id: -1, name: 'group_total'}, ...d.users.shift_2]
      }
      [...(d.users.shift_2 ?? []), ...(d.users.shift_1 ?? [])].forEach((u) => {
        if (u.id <= 0) return;
        if (!ids[u.id]) ids[u.id] = [];
        ids[u.id].push(d.schedule);
      })
    })
    // console.log(ids);
    this.groupRowSpan = this.editGroup.data.reduce((acc, d) => {
      const s1_count = (d.users.shift_1 ?? []).length
      const s2_count = (d.users.shift_2 ?? []).length
      acc[d.group.id] = (s1_count > s2_count ? s1_count : s2_count) + 1;
      return acc;
    }, {})
    this.pageHash = moment().unix();
    this.getUsersStats(ids);

    this.$socket.client.on('personal_user_' + this.$currentUID, (payload) => {
      if (payload.type === 'ordersStatsByManager') {
        const data = JSON.parse(payload.data);
        if (+data.pageHash !== this.pageHash) return;
        console.log(data?.user_id);
        // this.usersStats[data.user_id] = data.statData;
        this.$set(this.usersStats, data.user_id, data.statData);
        // this.loading = false;
        // if (!this.stats) this.stats = {};
        // this.stats = {...this.stats, ...JSON.parse(payload.data)};
      }
    })

  },
  computed: {
    $AllProjects() {
      return this.$store.getters['platform/projects'].reduce((acc, p) => {
        acc[p.id] = p;
        return acc;
      }, {})
    },
  },
  methods: {
    async getUsersStats(users) {
      const {data} = await api.post('/new/orders/statistics', {
        type: 2,
        users: users,
        page_hash: this.pageHash,
        user_id: this.$currentUID,
        // schedules: Object.keys(this.schedule).reduce((acc, id) => {
        //   acc[id] = {start: this.schedule[id].start, end: this.schedule[id].end};
        //   return acc;
        // }, {}),
        dateRange: this.dateRange,
      })
      if (data.success) {
      } else {
        toastr['error']('Ошибка при сборе статистики', 'Ошибка');
      }
    },
    getSum(alias, subAlias, index, group, shift = false) {
      // console.log(alias, subAlias, index, group);
      let sumData = {total: 0, sum: 0, percent: 0};
      let userId;
      // console.log(alias, subAlias, group);
      switch (alias) {
        case 'probablyClose':
        case 'closedOrders':
        case 'done':
        case 'rej_man':
        case 'rej_run':
          let arrStatIndex = [3];
          if (alias === 'done') arrStatIndex = [1];
          if (alias === 'rej_man') arrStatIndex = [-2];
          if (alias === 'rej_run') arrStatIndex = [-3];
          if (alias === 'probablyClose') arrStatIndex = [1, 3];

          userId = group?.users?.[`shift_${shift}`]?.[index]?.id ?? false;

          if (+userId === -1) {
            const users = (group?.users?.[`shift_${shift}`] ?? []).map((u) => u.id);
            const allUsers = [...(group?.users?.[`shift_1`] ?? []).map((u) => u.id), ...(group?.users?.[`shift_2`] ?? []).map((u) => u.id)];
            // console.log(allUsers);
            const totalData = allUsers.reduce((acc, uId) => {
              arrStatIndex.forEach((statIndex) => {
                acc.group.total += +(this.stats[group?.schedule]?.[uId]?.[statIndex]?.total ?? 0);
                acc.group.sum += +(this.stats[group?.schedule]?.[uId]?.[statIndex]?.price ?? 0);
                if (users.includes(uId)) {
                  acc.user.total += +(this.stats[group?.schedule]?.[uId]?.[statIndex]?.total ?? 0);
                  acc.user.sum += +(this.stats[group?.schedule]?.[uId]?.[statIndex]?.price ?? 0);
                }
              });
              return acc;
            }, {user: {total: 0, sum: 0, t_percent: 0, s_percent: 0}, group: {total: 0, sum: 0}})
            totalData.user.t_percent = Math.round(totalData.user.total * 100 / (totalData.group.total || 1) * 10) / 10;
            totalData.user.s_percent = Math.round(totalData.user.sum * 100 / (totalData.group.sum || 1) * 10) / 10;


            if (subAlias === 'grand_total' || subAlias === 'grand_sum') {
              if (subAlias === 'grand_total') return `<strong>${Math.round(totalData.group.total * 10) / 10}</strong>`;
              return `<strong>${Math.round(totalData.group.sum / 100) / 10}k</strong>`;
            }

            if (subAlias === 'total') return `<strong>${Math.round(totalData.user.total * 10) / 10} ${totalData.user.total ? '(' + totalData.user.t_percent + '%)' : ''}</strong>`;
            if (subAlias === 'sum') return `<strong>${Math.round(totalData.user.sum / 100) / 10}k ${totalData.user.sum ? '(' + totalData.user.s_percent + '%)' : ''}</span></strong>`;
            break;
          }

          if (userId) {
            const totalData = [1, 2].reduce((acc, i) => {
              const uId = group?.users?.[`shift_${i}`]?.[index]?.id ?? false;
              arrStatIndex.forEach((statIndex) => {
                if (uId) {
                  acc.group.total += +(this.stats[group?.schedule]?.[uId]?.[statIndex]?.total ?? 0);
                  acc.group.sum += +(this.stats[group?.schedule]?.[uId]?.[statIndex]?.price ?? 0);
                }
                if (+uId === +userId) {
                  acc.user.total += +(this.stats[group?.schedule]?.[uId]?.[statIndex]?.total ?? 0);
                  acc.user.sum += +(this.stats[group?.schedule]?.[uId]?.[statIndex]?.price ?? 0);
                }
              });
              return acc;
            }, {user: {total: 0, sum: 0, t_percent: 0, s_percent: 0}, group: {total: 0, sum: 0}});
            totalData.user.t_percent = Math.round(totalData.user.total * 100 / (totalData.group.total || 1) * 10) / 10;
            totalData.user.s_percent = Math.round(totalData.user.sum * 100 / (totalData.group.sum || 1) * 10) / 10;

            if (subAlias === 'grand_total' || subAlias === 'grand_sum') {
              const total = Object.keys(group?.users ?? {}).reduce((acc, shf) => {
                (group?.users?.[shf] ?? []).forEach((u) => {
                  Object.values(this.stats[group?.schedule]?.[u.id] ?? {}).forEach((d) => {
                    acc.total += d.total;
                    acc.sum += d.price;
                  })
                })
                return acc;
              }, {total: 0, sum: 0});
              if (subAlias === 'grand_total') return `<strong>${Math.round(totalData.group.total * 10) / 10} ${totalData.group.total ? '(' + Math.round(totalData.group.total * 100 / (total.total || 1)) + '%)' : ''}</strong>`;
              return `<strong>${Math.round(totalData.group.sum / 100) / 10}k ${totalData.group.sum ? '(' + Math.round(totalData.group.sum * 100 / (total.sum || 1)) + '%)' : ''}</strong>`;
            }

            if (subAlias === 'total') return `<strong>${Math.round(totalData.user.total * 10) / 10} ${totalData.user.total ? '(' + totalData.user.t_percent + '%)' : ''}</strong>`;
            if (subAlias === 'sum') return `<strong>${Math.round(totalData.user.sum / 100) / 10}k ${totalData.user.sum ? '(' + totalData.user.s_percent + '%)' : ''}</span></strong>`;
            break;
          }
          return 0;
        case 'total':
          [1, 2].forEach((shift) => {
            userId = group?.users?.['shift_' + shift]?.[index]?.id ?? false;
            if (userId) {
              let arrayUsersIds = [userId];
              if (userId === -1) {
                arrayUsersIds = (group?.users?.['shift_' + shift] ?? []).map((u) => u.id);
              }
              arrayUsersIds.forEach((uId) => {
                if (!uId) return;
                Object.values(this.stats[group?.schedule]?.[uId] ?? {}).forEach((d) => {
                  sumData.total += d.total;
                  sumData.sum += d.price;
                })
              });
            }
          });

          // userId = group?.users?.shift_2?.[index]?.id ?? false;
          // if (userId) {
          //   Object.values(this.stats[group?.schedule]?.[userId] ?? {}).forEach((d) => {
          //     sumData.total += d.total;
          //     sumData.sum += d.price;
          //   })
          // }
          return `всего заявок: <strong>${Math.round((sumData.total * 10) / 10)} (${Math.round(sumData.sum / 100) / 10}k)</strong>`;
      }
    },
    printUserStat(stat) {
      const data = Object.keys(stat).reduce((acc, status) => {
        acc.total += stat[status].total;
        if (+status === 1 || +status === 3) {
          acc.pass += stat[status].total;
          acc.pass_price += stat[status].price;
        }
        return acc;
      }, {total: 0, pass: 0, pass_price: 0});
      const percentPass = Math.round(data.pass * 100 / (data.total === 0 ? 1 : data.total));
      return (Math.round(data.total * 10) / 10) + '/' + (percentPass ?? 0) + '% ( ' + Math.round(data.pass_price / 1000) + 'k )';
    },
    getAllShiftStats(group, shift) {
      const users = (group.users[`shift_${shift}`] ?? []).map((u) => u.id);
      if (users.length === 1) return null;
      return Object.keys(this.stats[group.schedule] ?? []).reduce((acc, k) => {
        if (users.includes(+k)) {
          Object.keys(this.stats[group.schedule][k]).forEach((status) => {
            if (!acc[status]) acc[status] = {price: 0, total: 0};
            acc[status].price += this.stats[group.schedule][k][status].price;
            acc[status].total += this.stats[group.schedule][k][status].total;
          })
        }
        return acc;
      }, {});
    }
  }
}

</script>

<style scoped>
.w-small {
  width: 185px;
}

.gray {
  background-color: lightgrey;
}

.first_block_tr {
  border-top: 3px solid gray;
}

.tr_total_orders {
  background-color: #09ff0921;
}

.total_order_figures {
  background-color: #5367ff1f;
}

.mw_ht {
  width: 230px;
}

.stat_td {
  min-width: 550px;
}

.bg_1 {
  background-color: #04eb041f;
}

.empty_td {
  height: 0;
  padding: 0;
  border-top: 0;
}
</style>
